import { render } from "./ResetPasswordScreen.vue?vue&type=template&id=204a09fa&scoped=true"
import script from "./ResetPasswordScreen.vue?vue&type=script&lang=js"
export * from "./ResetPasswordScreen.vue?vue&type=script&lang=js"

import "./ResetPasswordScreen.vue?vue&type=style&index=0&id=204a09fa&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204a09fa"]])

export default __exports__